import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MerchantAccountListItem } from '../../models';
import { PersonModalComponent } from '../../modals';

@Component({
    templateUrl: './person.component.html'
})
export class PersonComponent implements ICellRendererAngularComp {

    private modalRef: NgbModalRef;
    merchantAccount: MerchantAccountListItem;

    constructor(
        private modalService: NgbModal
    ) {

    }

    agInit(params: any): void {
        this.merchantAccount = params.data;
    }

    refresh(): boolean {
        return false;
    }

    openPersonModal() {
        this.modalRef = this.modalService.open(PersonModalComponent);
        this.modalRef.componentInstance.universityPerson = this.merchantAccount.contact;
    }
}